import _classCallCheck from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import { ConsoleLogger as Logger } from './Logger';
var logger = new Logger('Parser');
export var parseMobileHubConfig = function parseMobileHubConfig(config) {
  var amplifyConfig = {}; // Analytics

  if (config['aws_mobile_analytics_app_id']) {
    var Analytics = {
      AWSPinpoint: {
        appId: config['aws_mobile_analytics_app_id'],
        region: config['aws_mobile_analytics_app_region']
      }
    };
    amplifyConfig.Analytics = Analytics;
  } // Auth


  if (config['aws_cognito_identity_pool_id'] || config['aws_user_pools_id']) {
    amplifyConfig.Auth = {
      userPoolId: config['aws_user_pools_id'],
      userPoolWebClientId: config['aws_user_pools_web_client_id'],
      region: config['aws_cognito_region'],
      identityPoolId: config['aws_cognito_identity_pool_id'],
      mandatorySignIn: config['aws_mandatory_sign_in'] === 'enable'
    };
  } // Storage


  var storageConfig;

  if (config['aws_user_files_s3_bucket']) {
    storageConfig = {
      AWSS3: {
        bucket: config['aws_user_files_s3_bucket'],
        region: config['aws_user_files_s3_bucket_region']
      }
    };
  } else {
    storageConfig = config ? config.Storage || config : {};
  }

  amplifyConfig.Analytics = Object.assign({}, amplifyConfig.Analytics, config.Analytics);
  amplifyConfig.Auth = Object.assign({}, amplifyConfig.Auth, config.Auth);
  amplifyConfig.Storage = Object.assign({}, storageConfig);
  logger.debug('parse config', config, 'to amplifyconfig', amplifyConfig);
  return amplifyConfig;
};
/**
 * @deprecated use per-function export
 */

export var Parser = function Parser() {
  _classCallCheck(this, Parser);
};
Parser.parseMobilehubConfig = parseMobileHubConfig;
/**
 * @deprecated use per-function export
 */

export default Parser;